import React from "react";
import PropTypes from "prop-types";
import { text, primary } from "@govlaunch/palette";
import translatePropsIntoFontSize from "../measure/translatePropsIntoFontSize";

/**
 * @param  {Boolean} active
 * @return {?Object}
 */
function applyActiveStyles(active) {
  if (active) {
    return {
      color: primary,
      fontWeight: 400,
    };
  }

  return null;
}

export default function Option({ children, active, ...props }) {
  return (
    <div
      css={{
        position: "relative",
        cursor: "pointer",
        display: "block",
        border: "none",
        height: "auto",
        textAlign: "left",
        borderTop: "none",
        color: text,
        ...translatePropsIntoFontSize(props),
        fontWeight: 400,
        textTransform: "none",
        boxShadow: "none",
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 10,
        paddingBottom: 10,
        wordWrap: "normal",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        ...applyActiveStyles(active),
      }}
      {...props}
    >
      {children}
    </div>
  );
}

Option.propTypes = {
  children: PropTypes.node.isRequired,
  active: PropTypes.bool,
};

Option.defaultProps = {
  active: false,
};
